import { Type, Loc, Cache, getCookie, setCookie, addCustomEvent, onCustomEvent, removeCustomEvent } from 'main.core';
import { Button, ButtonColor } from 'ui.buttons';
import { Confetti } from 'ui.confetti';

export const PersonalOffer = (function () {
	const PersonalOffer = function ({ componentId, result, params }) {
		this.componentId = componentId;
		this.result = result;
		this.params = params;
		this.params.TIME_UPDATE = this.params.TIME_UPDATE || 10000;
		this.title = Loc.getMessage('SPECIAL_OFFER_POPUP_TITLE');
		this.text = Loc.getMessage('SPECIAL_OFFER_POPUP_TEXT');
		this.btnText = Loc.getMessage('SPECIAL_OFFER_BTN_TEXT');
		this.link = this.params.DETAIL_URL;
		this.userId = Loc.getMessage('USER_ID');
		this.isShowedCookieName = 'specOffersShowed' + this.params.SOURCE + this.userId;
		this.isShowedPopupCookieName = 'specOffersShowedPopup' + this.params.SOURCE + this.userId;
		this.isShowed = getCookie(this.isShowedCookieName) === 'Y';
		this.isShowedPopup = getCookie(this.isShowedPopupCookieName) === 'Y';
		this.isAuthorized = !!this.userId;
		this.showType = 'notification';
		this.cookieOptions = { expires: 86400, path: '/', secure: false };
		this.showInfo();
	}
	PersonalOffer.prototype = {
		requestOffers() {
			BX.ajax.runComponentAction('germes:sale.personal.spec.offers', 'getStatus', {
				mode: 'ajax',
			}).then(response => {
				if (response.data.STATUS !== undefined && response.data.STATUS == 'COMPLETE') {
					this.result = response.data;
					this.showInfo();
				} else {
					setTimeout(this.requestOffers, this.params.TIME_UPDATE);
				}
			}, response => {
				console.info(response);
			});
		},
		showInfo() {
			const isOfferPage = window.location.pathname.indexOf(this.link) !== -1;
			if (!isOfferPage) {
				if (!this.isShowed) {
					if (!this.result) {
						this.result = this.requestOffers();
					} else {
						if (!this.isShowedPopup) {
							this.showPopup();
							setCookie(this.isShowedPopupCookieName, 'Y', this.cookieOptions);
						} else {
							this.showNotification();
						}
					}
				}
			} else {
				setCookie(this.isShowedCookieName, 'Y', this.cookieOptions);
			}
		},
		showNotification() {
			BX.UI.Notification.Center.notify({
				content: '<i class="fas fa-gift"></i> ' + this.title,
				category: 'personal-offers',
				position: 'bottom-right',
				autoHideDelay: this.params.TIME_UPDATE * 100,
				closeButton: false,
				actions: [{
					title: this.btnText,
					href: this.link,
				}]
			});
		},
		showPopup() {
			BX.PopupWindowManager.create('spec-offers-info', null, {
				width: window.innerWidth > 400 ? 400 : window.innerWidth, // ширина окна
				closeIcon: {
					right: "20px",
					top: "10px"
				},
				titleBar: {
					content: BX.create('span', {
						html: `<h1 class="h4 py-2 text-center">${this.title}</h1>`,
						props: {
							className: 'basketConfirmer-title-bar'
						}
					})
				},
				content: `<div class="text-center">
                    <h3>${this.text}</h3>
                    <a href="${this.link}" class="ui-btn ui-btn-success" title="${this.title}" rel="index" target="_self">${this.btnText}</a>
                </div>`,
				zIndex: 0,
				offsetLeft: 0,
				offsetTop: 0,
				draggable: {
					restrict: false
				},
				closeByEsc: true,
				darkMode: false,
				lightShadow: true,
				overlay: { backgroundColor: '#fff', opacity: '80' },
				autoHide: true
			}).show();
			BX.UI.Confetti?.fire({
				particleCount: 100,
				spread: 100,
				origin: { y: 0.6 }
			});
		},
	}
	return PersonalOffer;
})();
